const setNewsDetailMovie = () => {
  const newsMovies = document.querySelectorAll('.news-detail .news-movie video');

  function videoLoaded(movie) {
    let width = movie.videoWidth;
    let height = movie.videoHeight;
    const aspect = height / width * 100;
    const parent = movie.parentNode;
    parent.style.paddingTop = aspect + '%';
  }

  for(const movie of newsMovies) {
    videoLoaded(movie)
  }
}

export default setNewsDetailMovie;